import loadable from '@loadable/component';

export const CmsPostPageLoadable = loadable(() => import('./CmsPostPage'), {
  resolveComponent: (module) => module.CmsPostPage,
});
